import { IProdutoDafForm } from '../../../../../../modules/types/ProdutoDaf';

const numberToSN = (value?: number): 'S' | 'N' => (value === 1 ? 'S' : 'N');

const emptyToUndefined = (value?: string): string | undefined =>
  value && value.trim() !== '' ? value : undefined;

export const produtoDafFormToApi = (form?: IProdutoDafForm | null) => {
  if (!form) return null;

  return {
    id: form.id ? Number(form.id) : undefined,
    obmVmpId: Number(form.obmVmpId),
    denominacaoGenericaId: Number(form.denominacaoGenericaId),

    aware: Number(form.aware),
    formaFarmaceutica: Number(form.formaFarmaceutica),
    formaFarmaceuticaSimp: Number(form.formaFarmaceuticaSimp),
    umidade: Number(form.umidade),
    acondicionamento: Number(form.acondicionamento),
    statusRename: Number(form.statusRename),
    listaPaciente: Number(form.listaPaciente),
    especializadoGrupo: Number(form.especializadoGrupo),
    oncologicoGrupo: Number(form.oncologicoGrupo),

    produtoFarmaceutico: form.produtoFarmaceutico,
    concentracao: form.concentracao,
    codigoAtc: form.codigoAtc,

    oncologico: numberToSN(Number(form.oncologico)),
    biologico: numberToSN(Number(form.biologico)),
    doencaRara: numberToSN(Number(form.doencaRara)),
    statusDistribuicao: numberToSN(Number(form.statusDistribuicao)),

    compBasico: numberToSN(Number(form.compBasico)),
    compEspecializado: numberToSN(Number(form.compEspecializado)),
    compEstrategico: numberToSN(Number(form.compEstrategico)),
    compOncologico: numberToSN(Number(form.compOncologico)),
    compRara: numberToSN(Number(form.compRara)),
    usoHospitalar: numberToSN(Number(form.usoHospitalar)),
    farmaciaPopular: numberToSN(Number(form.farmaciaPopular)),

    dataRenamePublicacao: emptyToUndefined(form.dataRenamePublicacao),
    dataRenameAmpliacao: emptyToUndefined(form.dataRenameAmpliacao),
    dataRenameExclusao: emptyToUndefined(form.dataRenameExclusao),

    regraValidacao: emptyToUndefined(form.regraValidacao),
    observacoes: form.observacoes?.trim() || 'Sem observações.',
  };
};
